import { render } from "./TheManual.vue?vue&type=template&id=f8e471ca&scoped=true"
import script from "./TheManual.vue?vue&type=script&lang=js"
export * from "./TheManual.vue?vue&type=script&lang=js"

import "./TheManual.vue?vue&type=style&index=0&id=f8e471ca&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e471ca"]])

export default __exports__